import React, {Component, ReactElement, ReactNode} from 'react'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import {NatGetRoomToResidentDetails} from '../roomToResident/repository/NatGetRoomToResidentDetails'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Messages} from '../../../Messages'
import {Nullable} from '../../../app/TypeHelpers'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import PPTextField from '../../../components/shared/forms/PPTextField'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import {ConditionTableFixed} from '../../../styledComponents/adminPage/ConditionTable'
import {ADMINISTORATOR_MODE, AVAILABLE_OR_NOT, HAVE_OR_NOT, MESSAGE_TYPE, ROLE_FOR_RESIDENT} from '../../../CodeMaster'
import {
    NatPutNonPersonalInfoRoomToResident,
    NatPutNonPersonalInfoRoomToResidentParams,
} from '../roomToResident/repository/NatPutNonPersonalInfoRoomToResident'
import PPRadioGroup, {PPRadioItemProp} from '../../../components/shared/forms/PPRadioGroup'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import {formatForDateInput} from '../../../formatters/formatDate'
import {AcceptedWarning, Warning} from '../common/admin/NatAcceptedWarning'
import NatAdminCommonAcceptedWarningComponent from '../common/admin/NatAdminCommonAcceptedWarningComponent'
import {autoKanaOnUpdate, getAcceptedWarningList, setHighlightingWarningList} from '../../common/util/Natutil'
import {createRejectionResidentUserRegistrationApplyInfoMessage} from './NatAdminResidentUserHelper'
import {Box, TableBody, TableCell, TableRow} from '@mui/material';
import {NatGetCondominium} from '../condominium/repository/NatGetCondominium'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import {
    AdminLoginInfoSessionStorageKey,
    NatAdminLoginInfoSessionStorageHelper,
} from '../../common/authentication/NatAdminLoginInfoSessionStorageHelper'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    ridgeCd: string
    roomNumber: string
    seq: string
    roomToResidentRepo: NatRoomToResidentRepo
    condominiumRepo: NatCondominiumRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    selectedRole: string
    roleName: string
    adminFamilyName: string
    adminFirstName: string
    adminFamilyNameKana: string
    adminFirstNameKana: string
    validPeriodStartDate: string
    validPeriodEndDate: string
    cardKeyNumber: string
    mainUserFlag: boolean
    selectedCondominiumCardKey: string
    memo: string
    roomToResidentVersion: number
    acceptAll: boolean
    acceptedWarning: AcceptedWarning[]
    warnings: Warning[]
    isLoadCompleted: boolean
    facilityReserveAvailability: string
    ridgeCd: string
    ridgeName: string
    roomNumber: string
    condominiumGroupName: string
    condominiumName: string
    convertAdminFamilyNameKana: string
    preAdminFamilyNameKana: string
    convertAdminFirstNameKana: string
    preAdminFirstNameKana: string
}

const highlightingMessegIdList: string[] = [Messages.WRESA0006.id]

class NatAdminResidentUserEditForAdminNamePage extends Component<Props & AdminPagePropsSet, States> {
    administratorMode: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.administratorMode = NatAdminLoginInfoSessionStorageHelper
            .getStringItemOrNull(AdminLoginInfoSessionStorageKey.SELECTED_MODE)

        this.state = {
            selectedRole: '',
            roleName: '',
            adminFamilyName: '',
            adminFirstName: '',
            adminFamilyNameKana: '',
            adminFirstNameKana: '',
            validPeriodStartDate: '',
            validPeriodEndDate: '',
            cardKeyNumber: '',
            mainUserFlag: false,
            selectedCondominiumCardKey: HAVE_OR_NOT.NOT.value,
            memo: '',
            roomToResidentVersion: 0,
            acceptAll: false,
            acceptedWarning: [],
            warnings: [],
            isLoadCompleted: false,
            facilityReserveAvailability: '',
            ridgeCd: '',
            ridgeName: '',
            roomNumber: '',
            condominiumGroupName: '',
            condominiumName: '',
            convertAdminFamilyNameKana: '',
            preAdminFamilyNameKana: '',
            convertAdminFirstNameKana: '',
            preAdminFirstNameKana: '',
        }
        this.onChangecardKeyNumber = this.onChangecardKeyNumber.bind(this)
        this.onChangeAdminFamilyName = this.onChangeAdminFamilyName.bind(this)
        this.onChangeAdminFirstName = this.onChangeAdminFirstName.bind(this)
        this.onChangeAdminFamilyNameKana = this.onChangeAdminFamilyNameKana.bind(this)
        this.onChangeAdminFirstNameKana = this.onChangeAdminFirstNameKana.bind(this)
        this.onChangeValidPeriodStartDate = this.onChangeValidPeriodStartDate.bind(this)
        this.onChangeValidPeriodEndDate = this.onChangeValidPeriodEndDate.bind(this)
        this.registerResidentUser = this.registerResidentUser.bind(this)
        this.residentUserListLinkClick = this.residentUserListLinkClick.bind(this)
        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.onChangeSelectRole = this.onChangeSelectRole.bind(this)
        this.onChangeMemo = this.onChangeMemo.bind(this)
        this.onChangeAcceptedWarnings = this.onChangeAcceptedWarnings.bind(this)
        this.onChangeSelectFacilityReserveAvailability = this.onChangeSelectFacilityReserveAvailability.bind(this)
        this.onCompositionUpdateAdminFamilyName = this.onCompositionUpdateAdminFamilyName.bind(this)
        this.onCompositionStartAdminFamilyName = this.onCompositionStartAdminFamilyName.bind(this)
        this.onCompositionUpdateAdminFirstName = this.onCompositionUpdateAdminFirstName.bind(this)
        this.onCompositionStartAdminFirstName = this.onCompositionStartAdminFirstName.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 部屋居住者取得
            const roomToResidentDetails: Nullable<NatGetRoomToResidentDetails> = await this.props.asyncCallFunction(
                this.props.roomToResidentRepo.getRoomToResidentDetails.bind(this.props.roomToResidentRepo,
                    this.props.condominiumCd, this.props.ridgeCd, this.props.roomNumber, this.props.seq),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (roomToResidentDetails && roomToResidentDetails.details) {
                const mainUserFlag: boolean = !roomToResidentDetails.details.parentResidentId

                this.setState({
                    selectedRole: roomToResidentDetails.details.roleId,
                    roleName: roomToResidentDetails.details.roleName,
                    adminFamilyName: roomToResidentDetails.details.adminFamilyName,
                    adminFirstName: roomToResidentDetails.details.adminFirstName,
                    adminFamilyNameKana: roomToResidentDetails.details.adminFamilyNameKana,
                    adminFirstNameKana: roomToResidentDetails.details.adminFirstNameKana,
                    validPeriodStartDate: roomToResidentDetails.details.validPeriodStartDate,
                    validPeriodEndDate: roomToResidentDetails.details.validPeriodEndDate,
                    cardKeyNumber: roomToResidentDetails.details.cardKeyNumber,
                    memo: roomToResidentDetails.details.memo,
                    mainUserFlag: mainUserFlag,
                    roomToResidentVersion: roomToResidentDetails.details.roomToResidentVersion,
                    isLoadCompleted: true,
                    facilityReserveAvailability:
                        (roomToResidentDetails.details.facilityReserveAvailability) ?
                            roomToResidentDetails.details.facilityReserveAvailability :
                            AVAILABLE_OR_NOT.AVAILABLE.value,
                    ridgeCd: roomToResidentDetails.details.ridgeCd,
                    ridgeName: roomToResidentDetails.details.ridgeName,
                    roomNumber: roomToResidentDetails.details.roomNumber,
                    condominiumGroupName: roomToResidentDetails.details.condominiumGroupName,
                    condominiumName: roomToResidentDetails.details.condominiumName,
                })
            }
            // 物件カードキー連携フラグを設定する
            const condominiumResponse: Nullable<NatGetCondominium> = await this.props.asyncCallFunction(
                this.props.condominiumRepo.getCondominium.bind(
                    this.props.condominiumRepo, this.props.condominiumCd,
                ),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (condominiumResponse && condominiumResponse.details) {
                this.setState({
                    selectedCondominiumCardKey: condominiumResponse.details.cardKey,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // 権限
    getRoleMasterRadioGroupData(): PPRadioItemProp[] {
        return ROLE_FOR_RESIDENT.values().map((role) => (
            {
                label: role.label,
                value: role.value,
                radioProps: {
                    autoFocus: (role.value === this.state.selectedRole),
                    onChange: this.onChangeSelectRole,
                    checked: role.value === this.state.selectedRole,
                },
            }
        ))
    }

    // 施設予約可否
    getFacilityReserveAvailabilityRadioGroupData(): PPRadioItemProp[] {
        const facilityReserveAvailabilityRadioGroupData: PPRadioItemProp[] = []
        AVAILABLE_OR_NOT.values().map((facilityReserveAvailability) => (
            facilityReserveAvailabilityRadioGroupData.push(
                {
                    label: facilityReserveAvailability.label,
                    value: facilityReserveAvailability.value,
                    radioProps: {
                        onChange: this.onChangeSelectFacilityReserveAvailability,
                        checked: facilityReserveAvailability.value ===
                            this.state.facilityReserveAvailability,
                    },
                },
            )
        ))
        return facilityReserveAvailabilityRadioGroupData

    }

    onCompositionStartAdminFamilyName(): void {
        this.setState({
            convertAdminFamilyNameKana: '',
            preAdminFamilyNameKana: this.state.adminFamilyNameKana ?? '',
        })
    }

    onCompositionUpdateAdminFamilyName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertAdminFamilyNameKana: this.state.preAdminFamilyNameKana + kana})
        })
    }

    onCompositionStartAdminFirstName(): void {
        this.setState({
            convertAdminFirstNameKana: '',
            preAdminFirstNameKana: this.state.adminFirstNameKana ?? '',
        })
    }

    onCompositionUpdateAdminFirstName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertAdminFirstNameKana: this.state.preAdminFirstNameKana + kana})
        })
    }

    onChangecardKeyNumber(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            cardKeyNumber: event.target.value,
        })
    }

    onChangeAdminFamilyName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            adminFamilyName: event.target.value,
            adminFamilyNameKana: event.target.value ? this.state.convertAdminFamilyNameKana : '',
        })
    }

    onChangeAdminFirstName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            adminFirstName: event.target.value,
            adminFirstNameKana: event.target.value ? this.state.convertAdminFirstNameKana : '',
        })
    }

    onChangeAdminFamilyNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({adminFamilyNameKana: event.target.value})
    }

    onChangeAdminFirstNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({adminFirstNameKana: event.target.value})
    }

    onChangeSelectRole(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({selectedRole: event.target.value})
    }

    onChangeValidPeriodStartDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({validPeriodStartDate: date.toString()})
        } else {
            this.setState({validPeriodStartDate: ''})
        }
    }

    onChangeValidPeriodEndDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({validPeriodEndDate: date.toString()})
        } else {
            this.setState({validPeriodEndDate: ''})
        }
    }

    onChangeMemo(event: React.ChangeEvent<HTMLTextAreaElement>): void {
        this.setState({memo: event.target.value as string})
    }

    onChangeAcceptedWarnings(acceptAll: boolean, acceptedWarning: AcceptedWarning[]): void {
        this.setState({
            acceptAll: acceptAll,
            acceptedWarning: acceptedWarning,
        })
    }

    onChangeSelectFacilityReserveAvailability(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({facilityReserveAvailability: event.target.value as string})
    }

    residentUserListLinkClick(): void {
        this.props.navigate(`/admin/residentUser/${this.props.condominiumCd}/${this.props.ridgeCd}/${this.props.roomNumber}/${this.props.seq}`,
        )
    }

    // 登録ボタン押下
    async registerResidentUser(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0010.errorLevel,
                message: Messages.IOPCC0010.toString('居住者ユーザ'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleRegisterOkClick,
                    },
                ],
            },
        )
    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleRegisterOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()

        try {
            const request: NatPutNonPersonalInfoRoomToResidentParams = {
                condominiumCd: this.props.condominiumCd,
                ridgeCd: this.props.ridgeCd,
                roomNumber: this.props.roomNumber,
                seq: Number(this.props.seq),
                adminFamilyName: this.state.adminFamilyName,
                adminFirstName: this.state.adminFirstName,
                adminFamilyNameKana: this.state.adminFamilyNameKana,
                adminFirstNameKana: this.state.adminFirstNameKana,
                validPeriodStartDate: this.state.validPeriodStartDate
                    ? formatForDateInput(this.state.validPeriodStartDate) : '',
                validPeriodEndDate: this.state.validPeriodEndDate
                    ? formatForDateInput(this.state.validPeriodEndDate) : '',
                cardKeyNumber: this.state.cardKeyNumber,
                facilityReserveAvailability: this.state.facilityReserveAvailability,
                memo: this.state.memo,
                roomToResidentVersion: this.state.roomToResidentVersion,
            }

            if (this.state.mainUserFlag) {
                request.roleId = this.state.selectedRole ? this.state.selectedRole : ''
            }

            if (this.state.acceptedWarning.length > 0) {
                request.permissionWarning = this.state.acceptedWarning
            }

            // 居住者ユーザ更新
            const response: Nullable<NatPutNonPersonalInfoRoomToResident> = await this.props.asyncCallFunction(
                this.props.roomToResidentRepo.putNonPersonalInfoRoomToResidentForAdmin.bind(
                    this.props.roomToResidentRepo, request),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
                {defaultErrorTitle: Messages.EOPCA0002.toString('居住者ユーザ')},
            )

            if (response !== null && response.requestError === null) {
                if (response.informations !== null) {
                    this.setState({warnings: getAcceptedWarningList(response.informations)})
                } else {
                    let detailMessage: string = Messages.IOPCC0008.toString('居住者ユーザ')
                    if (response.details !== null &&
                        response.details.rejectionRegistrationApplyInfoList.length) {
                        const rejectionResidentUserRegistrationApplyInfoListMessage: string =
                            createRejectionResidentUserRegistrationApplyInfoMessage(
                                response.details.rejectionRegistrationApplyInfoList)
                        detailMessage = detailMessage + '\n' + rejectionResidentUserRegistrationApplyInfoListMessage
                    }
                    this.props.navigate(`/admin/residentUser/${this.props.condominiumCd}/${this.props.ridgeCd}/${this.props.roomNumber}/${this.props.seq}`,
                        {
                            state: {
                                initialMessage: {
                                    title: null,
                                    messageLevel: MESSAGE_TYPE.INFORMATION,
                                    detail: detailMessage,
                                },
                            },
                        },
                    )
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    renderInputFormTable(): ReactNode {
        return (
            <>

                <ConditionTableFixed>
                    <colgroup>
                        <col width={'25%'}/>
                        <col width={'15%'}/>
                        <col width={'20%'}/>
                        <col width={'20%'}/>
                        <col width={'20%'}/>
                    </colgroup>
                    <StyledTableCaption>居住者ユーザ情報</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            {(this.state.mainUserFlag) ?
                                <>
                                    <TableRowName required>権限</TableRowName>
                                    <TableCell colSpan={4}>
                                        <PPRadioGroup
                                            row
                                            data={this.getRoleMasterRadioGroupData()}
                                            eventKeys={['roleId']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </TableCell>
                                </> :
                                <>
                                    <TableRowName>権限</TableRowName>
                                    <TableCell colSpan={4}>
                                        {this.state.roleName}
                                    </TableCell>
                                </>
                            }
                        </TableRow>
                        {(this.administratorMode === ADMINISTORATOR_MODE.ALL.value) ?
                            <>
                                <TableRow>
                                    <TableRowName>物件グループ</TableRowName>
                                    <TableCell colSpan={4}>
                                        {this.state.condominiumGroupName}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableRowName>物件名</TableRowName>
                                    <TableCell colSpan={4}>
                                        {this.state.condominiumName}
                                    </TableCell>
                                </TableRow>
                            </> : null
                        }
                        <TableRow>
                            <TableRowName>棟名</TableRowName>
                            <TableCell colSpan={4}>
                                {this.state.ridgeCd +
                                    ' : ' + this.state.ridgeName}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>部屋番号</TableRowName>
                            <TableCell colSpan=
                                           {this.state.selectedCondominiumCardKey ===
                                           HAVE_OR_NOT.HAVE.value ? 2 : 4}>
                                {this.state.roomNumber}
                            </TableCell>
                            {this.state.selectedCondominiumCardKey === HAVE_OR_NOT.HAVE.value &&
                                <>
                                    {(this.state.mainUserFlag) ?
                                        <>
                                            <TableRowName required>カードキー番号</TableRowName>
                                            <TableCell colSpan={2}>
                                                <PPTextField
                                                    InputProps={{
                                                        inputProps: {
                                                            maxLength: 10,
                                                        },
                                                    }}
                                                    required
                                                    fullWidth
                                                    value={this.state.cardKeyNumber}
                                                    onChange={this.onChangecardKeyNumber}
                                                    eventKeys={['cardKeyNumber']}
                                                    eventEmitter={this.props.eventEmitter}
                                                />
                                            </TableCell>
                                        </> :
                                        <>
                                            <TableRowName>カードキー番号</TableRowName>
                                            <TableCell colSpan={2}>
                                                {this.state.cardKeyNumber}
                                            </TableCell>
                                        </>

                                    }
                                </>
                            }
                        </TableRow>
                        <TableRow>
                            <TableRowName>管理者確認用氏名</TableRowName>
                            <TableCell colSpan={2}>
                                姓
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            name: 'adminFamilyName',
                                            id: 'adminFamilyName',
                                            maxLength: 10,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    onInput={this.onChangeAdminFamilyName}
                                    onChange={this.onChangeAdminFamilyName}
                                    onCompositionStart={this.onCompositionStartAdminFamilyName}
                                    onCompositionUpdate={this.onCompositionUpdateAdminFamilyName}
                                    value={this.state.adminFamilyName}
                                    eventKeys={['adminFamilyName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                            <TableCell colSpan={2}>
                                名
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            name: 'adminFirstName',
                                            id: 'adminFirstName',
                                            maxLength: 10,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    onInput={this.onChangeAdminFirstName}
                                    onChange={this.onChangeAdminFirstName}
                                    onCompositionStart={this.onCompositionStartAdminFirstName}
                                    onCompositionUpdate={this.onCompositionUpdateAdminFirstName}
                                    value={this.state.adminFirstName}
                                    eventKeys={['adminFirstName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>管理者確認用氏名(フリガナ)</TableRowName>
                            <TableCell colSpan={2}>
                                セイ
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            name: 'adminFamilyNameKana',
                                            id: 'adminFamilyNameKana',
                                            maxLength: 20,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    onInput={this.onChangeAdminFamilyNameKana}
                                    onChange={this.onChangeAdminFamilyNameKana}
                                    value={this.state.adminFamilyNameKana}
                                    eventKeys={['adminFamilyNameKana']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                            <TableCell colSpan={2}>
                                メイ
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            name: 'adminFirstNameKana',
                                            id: 'adminFirstNameKana',
                                            maxLength: 20,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    onInput={this.onChangeAdminFirstNameKana}
                                    onChange={this.onChangeAdminFirstNameKana}
                                    value={this.state.adminFirstNameKana}
                                    eventKeys={['adminFirstNameKana']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>有効期間開始日</TableRowName>
                            <TableCell colSpan={2} style={{paddingBottom: 18, paddingTop: 21.5}}>
                                {(this.state.mainUserFlag) ?
                                    <PPDatePicker
                                        onChangeDate={this.onChangeValidPeriodStartDate}
                                        value={(this.state.validPeriodStartDate) ?
                                            new Date(this.state.validPeriodStartDate) : null}
                                        eventEmitter={this.props.eventEmitter}
                                        eventKeys={['validPeriodStartDate']}
                                    /> :
                                    <>
                                        {this.state.validPeriodStartDate}
                                    </>
                                }
                            </TableCell>
                            <TableRowName>有効期間終了日</TableRowName>
                            <TableCell colSpan={2} style={{paddingBottom: 18, paddingTop: 21.5}}>
                                {(this.state.mainUserFlag) ?
                                    <PPDatePicker
                                        onChangeDate={this.onChangeValidPeriodEndDate}
                                        value={(this.state.validPeriodEndDate) ?
                                            new Date(this.state.validPeriodEndDate) : null}
                                        eventEmitter={this.props.eventEmitter}
                                        eventKeys={['validPeriodEndDate']}
                                    /> :
                                    <>
                                        {this.state.validPeriodEndDate}
                                    </>
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>施設予約可否</TableRowName>
                            <TableCell colSpan={4}>
                                <PPRadioGroup
                                    row
                                    data={this.getFacilityReserveAvailabilityRadioGroupData()}
                                    eventKeys={['facilityReserveAvailability']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>メモ</TableRowName>
                            <TableCell colSpan={4}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 2000,
                                            minRows: 3,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    multiline
                                    value={this.state.memo}
                                    onChange={this.onChangeMemo}
                                    eventKeys={['memo']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </ConditionTableFixed>
            </>
        )
    }


    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={
                            (this.state.selectedCondominiumCardKey === HAVE_OR_NOT.HAVE.value &&
                                (!this.state.cardKeyNumber)) ||
                            (!this.state.selectedRole) ||
                            (!this.state.facilityReserveAvailability) ||
                            (this.state.warnings.length > 0 &&
                                !this.state.acceptAll)
                        }
                        onClick={this.registerResidentUser}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={this.residentUserListLinkClick}
                    >
                        居住者ユーザ詳細へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <PageMainArea>
                    <form>
                        {this.renderInputFormTable()}
                    </form>
                </PageMainArea>
                <Box height={16}/>
                <NatAdminCommonAcceptedWarningComponent
                    warnings={setHighlightingWarningList(highlightingMessegIdList, this.state.warnings)}
                    changeAcceptedWarnings={this.onChangeAcceptedWarnings}
                    doOpenAnimation={true}
                />
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }
}

export default createAdminPage(NatAdminResidentUserEditForAdminNamePage)
